<template>
  <v-menu v-if="attachments.length" open-on-hover top offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="second" icon v-bind="attrs" v-on="on">
        <v-icon class="attachment-icon">mdi-attachment</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item-group>
        <v-list-item v-for="(attachment, idx) in attachments" :key="idx" @click="fileUrl(attachment)">
          <v-list-item-content>
            <v-list-item-title> {{ attachment.name }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { buildDocumentUrl, downloadFile, fileReader } from "@/services/utils";
import CoolLightBox from "vue-cool-lightbox";
import { checkImageByMIMEType } from "@/core/services/image.service.js";

export default {
  name: "AttachmentListViewer",

  components: {
    CoolLightBox,
  },

  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  methods: {
    fileUrl(file) {
      this.$http
        .get(buildDocumentUrl(this.customerId, file.id), { responseType: "blob" })
        .then(response => {
          if (checkImageByMIMEType(response.data.type)) {
            this.$lightBox.showBlob(response.data);
            return;
          }

          downloadFile(file.name, response.data);
        })
        .catch(async err => {
          const fileData = await fileReader(err.response.data);
          const { message } = JSON.parse(fileData);

          await this.$dialog.notify.error(message ?? "Ошибка получения файла");
        });
    },
  },
};
</script>

<style scoped></style>
